import React, { useState, useRef, useEffect } from "react";

export const COUNTRY_CODES=[
  {d:"+1",   f:"🇺🇸", n:"United States / Canada"},
  {d:"+44",  f:"🇬🇧", n:"United Kingdom"},
  {d:"+353", f:"🇮🇪", n:"Ireland"},
  {d:"+49",  f:"🇩🇪", n:"Germany"},
  {d:"+33",  f:"🇫🇷", n:"France"},
  {d:"+39",  f:"🇮🇹", n:"Italy"},
  {d:"+34",  f:"🇪🇸", n:"Spain"},
  {d:"+31",  f:"🇳🇱", n:"Netherlands"},
  {d:"+32",  f:"🇧🇪", n:"Belgium"},
  {d:"+41",  f:"🇨🇭", n:"Switzerland"},
  {d:"+43",  f:"🇦🇹", n:"Austria"},
  {d:"+46",  f:"🇸🇪", n:"Sweden"},
  {d:"+47",  f:"🇳🇴", n:"Norway"},
  {d:"+45",  f:"🇩🇰", n:"Denmark"},
  {d:"+358", f:"🇫🇮", n:"Finland"},
  {d:"+48",  f:"🇵🇱", n:"Poland"},
  {d:"+7",   f:"🇷🇺", n:"Russia / Kazakhstan"},
  {d:"+380", f:"🇺🇦", n:"Ukraine"},
  {d:"+30",  f:"🇬🇷", n:"Greece"},
  {d:"+351", f:"🇵🇹", n:"Portugal"},
  {d:"+966", f:"🇸🇦", n:"Saudi Arabia"},
  {d:"+971", f:"🇦🇪", n:"United Arab Emirates"},
  {d:"+973", f:"🇧🇭", n:"Bahrain"},
  {d:"+974", f:"🇶🇦", n:"Qatar"},
  {d:"+965", f:"🇰🇼", n:"Kuwait"},
  {d:"+968", f:"🇴🇲", n:"Oman"},
  {d:"+962", f:"🇯🇴", n:"Jordan"},
  {d:"+961", f:"🇱🇧", n:"Lebanon"},
  {d:"+963", f:"🇸🇾", n:"Syria"},
  {d:"+964", f:"🇮🇶", n:"Iraq"},
  {d:"+970", f:"🇵🇸", n:"Palestine"},
  {d:"+967", f:"🇾🇪", n:"Yemen"},
  {d:"+20",  f:"🇪🇬", n:"Egypt"},
  {d:"+212", f:"🇲🇦", n:"Morocco"},
  {d:"+216", f:"🇹🇳", n:"Tunisia"},
  {d:"+213", f:"🇩🇿", n:"Algeria"},
  {d:"+218", f:"🇱🇾", n:"Libya"},
  {d:"+249", f:"🇸🇩", n:"Sudan"},
  {d:"+252", f:"🇸🇴", n:"Somalia"},
  {d:"+91",  f:"🇮🇳", n:"India"},
  {d:"+92",  f:"🇵🇰", n:"Pakistan"},
  {d:"+880", f:"🇧🇩", n:"Bangladesh"},
  {d:"+94",  f:"🇱🇰", n:"Sri Lanka"},
  {d:"+977", f:"🇳🇵", n:"Nepal"},
  {d:"+63",  f:"🇵🇭", n:"Philippines"},
  {d:"+62",  f:"🇮🇩", n:"Indonesia"},
  {d:"+60",  f:"🇲🇾", n:"Malaysia"},
  {d:"+65",  f:"🇸🇬", n:"Singapore"},
  {d:"+66",  f:"🇹🇭", n:"Thailand"},
  {d:"+84",  f:"🇻🇳", n:"Vietnam"},
  {d:"+86",  f:"🇨🇳", n:"China"},
  {d:"+81",  f:"🇯🇵", n:"Japan"},
  {d:"+82",  f:"🇰🇷", n:"South Korea"},
  {d:"+90",  f:"🇹🇷", n:"Turkey"},
  {d:"+972", f:"🇮🇱", n:"Israel"},
  {d:"+98",  f:"🇮🇷", n:"Iran"},
  {d:"+93",  f:"🇦🇫", n:"Afghanistan"},
  {d:"+61",  f:"🇦🇺", n:"Australia"},
  {d:"+64",  f:"🇳🇿", n:"New Zealand"},
  {d:"+27",  f:"🇿🇦", n:"South Africa"},
  {d:"+234", f:"🇳🇬", n:"Nigeria"},
  {d:"+254", f:"🇰🇪", n:"Kenya"},
  {d:"+233", f:"🇬🇭", n:"Ghana"},
  {d:"+255", f:"🇹🇿", n:"Tanzania"},
  {d:"+251", f:"🇪🇹", n:"Ethiopia"},
  {d:"+256", f:"🇺🇬", n:"Uganda"},
  {d:"+55",  f:"🇧🇷", n:"Brazil"},
  {d:"+52",  f:"🇲🇽", n:"Mexico"},
  {d:"+54",  f:"🇦🇷", n:"Argentina"},
  {d:"+57",  f:"🇨🇴", n:"Colombia"},
  {d:"+56",  f:"🇨🇱", n:"Chile"},
  {d:"+51",  f:"🇵🇪", n:"Peru"},
  {d:"+58",  f:"🇻🇪", n:"Venezuela"},
];

export default function CountryCodePicker({value, onChange, theme:t}){
  const dk=t!=="light";
  const [open,setOpen]=useState(false);
  const [search,setSearch]=useState("");
  const ref=useRef(null);
  const selected=COUNTRY_CODES.find(c=>c.d===value)||COUNTRY_CODES[0];
  const q=search.toLowerCase();
  const filtered=q?COUNTRY_CODES.filter(c=>c.n.toLowerCase().includes(q)||c.d.includes(q)):COUNTRY_CODES;
  useEffect(()=>{
    if(!open)return;
    const h=e=>{if(ref.current&&!ref.current.contains(e.target)){setOpen(false);setSearch("");}};
    document.addEventListener("mousedown",h);
    return()=>document.removeEventListener("mousedown",h);
  },[open]);
  return(
    <div ref={ref} style={{position:"relative",flexShrink:0}}>
      <button type="button" onClick={()=>setOpen(o=>!o)}
        className={dk?"p-inp-dark":"p-inp-light"}
        style={{display:"flex",alignItems:"center",gap:7,cursor:"pointer",width:"auto",padding:"11px 12px",whiteSpace:"nowrap",userSelect:"none"}}>
        <span style={{fontSize:20,lineHeight:1}}>{selected.f}</span>
        <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:13,color:dk?"rgba(255,255,255,.9)":"var(--cink,#1A1714)"}}>{selected.d}</span>
        <span style={{fontSize:9,opacity:.45,marginInlineStart:2}}>▾</span>
      </button>
      {open&&(
        <div style={{position:"absolute",top:"calc(100% + 6px)",left:0,zIndex:400,background:dk?"#1e1b18":"white",border:`1px solid ${dk?"rgba(255,255,255,.14)":"#E8E5E0"}`,borderRadius:10,width:270,boxShadow:"0 12px 36px rgba(0,0,0,.25)"}}>
          <div style={{padding:"8px 10px",borderBottom:`1px solid ${dk?"rgba(255,255,255,.08)":"#E8E5E0"}`}}>
            <input autoFocus value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="Search country or code…"
              style={{width:"100%",background:dk?"rgba(255,255,255,.08)":"#F5F4F2",border:`1px solid ${dk?"rgba(255,255,255,.12)":"#E8E5E0"}`,borderRadius:6,color:dk?"white":"var(--cink,#1A1714)",fontSize:13,padding:"7px 10px",outline:"none",fontFamily:"inherit"}}/>
          </div>
          <div style={{maxHeight:220,overflowY:"auto"}}>
            {filtered.length===0
              ?<div style={{padding:"12px",fontSize:12,color:dk?"rgba(255,255,255,.35)":"#A09A94",textAlign:"center"}}>No results</div>
              :filtered.map(c=>(
                <div key={c.d} onClick={()=>{onChange(c.d);setOpen(false);setSearch("");}}
                  style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",cursor:"pointer",background:value===c.d?(dk?"rgba(255,255,255,.09)":"#F5F4F2"):"transparent"}}
                  onMouseEnter={e=>e.currentTarget.style.background=dk?"rgba(255,255,255,.06)":"#F5F4F2"}
                  onMouseLeave={e=>e.currentTarget.style.background=value===c.d?(dk?"rgba(255,255,255,.09)":"#F5F4F2"):"transparent"}>
                  <span style={{fontSize:18,flexShrink:0,lineHeight:1}}>{c.f}</span>
                  <span style={{fontSize:13,color:dk?"rgba(255,255,255,.75)":"#4A4540",flex:1}}>{c.n}</span>
                  <span style={{fontSize:11,color:dk?"rgba(255,255,255,.38)":"#A09A94",fontFamily:"'JetBrains Mono',monospace"}}>{c.d}</span>
                </div>
              ))
            }
          </div>
        </div>
      )}
    </div>
  );
}
